<template>
	<div>
		<core-stakeholders-card
			:policyId="policyId"
			:stakeholders="stakeholders"
			stakeholdersOf="policy"
			@stakeholder:added="fetchStakeholders"
			@stakeholder:removed="removeStakeholder"
			:types="types"
		/>
	</div>
</template>

<script>
import CoreStakeholdersCard from "@/modules/core/components/CoreStakeholdersCard/"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: { CoreStakeholdersCard },

	props: {
		types: {
			type: Array,
			default: () => []
		}
	},

	data() {
		return {
			stakeholders: []
		}
	},

	computed: {
		policyId() {
			return this.$route.params.id
		}
	},

	methods: {
		async fetchStakeholders() {
			const query = gql`
				query policyStakeholders($where: policyWhereInput) {
					policies(where: $where) {
						list {
							stakeholders {
								id
								type
								entity {
									id
									name
								}
							}
						}
					}
				}
			`

			const res = await api({
				query,
				variables: { where: { id: this.policyId } }
			})

			this.stakeholders = res?.data?.policies?.list?.[0]?.stakeholders
		},

		removeStakeholder(stakeholderId) {
			this.stakeholders = this.stakeholders.filter(
				item => item.id !== stakeholderId
			)
		}
	},

	mounted() {
		this.fetchStakeholders()
	}
}
</script>
